import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Navbar.module.css';

// Gear SVG logo
const GearLogo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="4" fill="#1c2126" stroke="#f5c518" strokeWidth="2"/>
    <path d="M16 2v4M16 26v4M2 16h4M26 16h4M6.34 6.34l2.83 2.83M22.83 22.83l2.83 2.83M6.34 25.66l2.83-2.83M22.83 9.17l2.83-2.83" stroke="#f5c518" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="16" cy="16" r="7" stroke="#f5c518" strokeWidth="1.5" strokeDasharray="3 2"/>
  </svg>
);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <div className={`container ${styles.inner}`}>
        {/* Logo */}
        <Link to="/" className={styles.logo} onClick={close}>
          <GearLogo />
          <div className={styles.logoText}>
            <span className={styles.logoName}>BRIGHT</span>
            <span className={styles.logoSub}>MACHINERIES</span>
          </div>
        </Link>

        {/* Desktop links */}
        <div className={styles.links}>
          {[
            { to: '/',          label: 'Home',       end: true },
            { to: '/stock',     label: 'Categories',  end: false },
            { to: '/about',     label: 'About Us',    end: false },
            { to: '/contact',   label: 'Contact Us',  end: false },
          ].map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
            >{item.label}</NavLink>
          ))}
        </div>

        {/* Call button desktop */}
        <a href="tel:+917506760967" className={styles.callBtn}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
          Call Now
        </a>

        {/* Hamburger */}
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.open : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile drawer */}
      <div className={`${styles.drawer} ${menuOpen ? styles.drawerOpen : ''}`}>
        {[
          { to: '/',        label: 'Home',      end: true },
          { to: '/stock',   label: 'Categories', end: false },
          { to: '/about',   label: 'About Us',   end: false },
          { to: '/contact', label: 'Contact Us', end: false },
        ].map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={close}
            className={({ isActive }) => `${styles.drawerLink} ${isActive ? styles.drawerActive : ''}`}
          >{item.label}</NavLink>
        ))}
        <div className={styles.drawerDivider} />
        <a href="tel:+917506760967" className={styles.drawerCall}>
          📞 Call: 7506760967
        </a>
      </div>
    </nav>
  );
}
